import { render, staticRenderFns } from "./paymentReceipt.vue?vue&type=template&id=10563654&scoped=true&"
import script from "./paymentReceipt.vue?vue&type=script&lang=js&"
export * from "./paymentReceipt.vue?vue&type=script&lang=js&"
import style0 from "./paymentReceipt.vue?vue&type=style&index=0&id=10563654&lang=scss&scoped=true&"
import style1 from "./paymentReceipt.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10563654",
  null
  
)

export default component.exports